<template>
  <div class="contractAdmin">
    <el-dialog
      title="分账比例配置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1360px"
      :before-close="close"
    >
      <div class="title">
        <el-button
          size="small"
          type="primary"
          @click="handleCreateContract"
        >创建分账合约</el-button>
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="产品项目" width="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.projectName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="type" label="分账方式" width="100" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.splitType === 'QUOTA'">定额抽佣</span>
            <span v-else-if="row.splitType === 'PERCENT'">按百分比</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="合约ID" min-width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitContractId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分账合约编号" min-width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitSubjectId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约名称" width="140" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitContractName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作为招生方保证金" width="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.checkAcceptStandard">{{ row.checkAcceptStandard }}元/人次</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="作为服务方保证金" width="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.agentCheckAcceptStandard">{{ row.agentCheckAcceptStandard }}元/人次</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" width="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertByName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="handleDelete(row.id)">删除</span>
            <span class="blue_Box" @click="openBillRatioSetting(row)">分账比例配置</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>
    <BindingContract ref="bindingContractRef" :type="type" @refresh="refresh" />
    <!-- 分账比例设置 -->
    <BillRatioSetting ref="billRatioSettingRef" :type="type" @refresh="refresh" />
  </div>
</template>

<script>
import {
  getContractList,
  deleteContractConfig,
} from "@/api/organization"
import BindingContract from '@/views/organization/components/bindingContract.vue'
import BillRatioSetting from '@/views/organization/components/billRatioSetting.vue'
import myPagination from "@/components/myPagination.vue"
export default {
  props: {
    type: {
      type: Number,
      required: true
    }
  },
  components: {
    BindingContract,
    BillRatioSetting,
    myPagination
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      companyId: "",
    }
  },
  methods: {
    // 点击创建合约
    handleCreateContract() {
      this.$refs.bindingContractRef.init(this.companyId, this.type)
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该分账比例配置吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteContractConfig({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1
                }
              }
              this.refresh()
              this.$message({
                type: "success",
                message: "删除成功!",
              })
            }
          })
        })
        .catch(() => {})
    },
    // 分账比例设置
    openBillRatioSetting(payload) {
      if (!payload.splitContractId) {
        return
      }
      this.$refs.billRatioSettingRef.init(payload);
    },
    // 刷新
    refresh() {
      this.handleGetContractList({
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      })
      this.$parent.refresh()
    },
    async handleGetContractList(payload) {
      this.loading = true
      this.pageInfo.page = payload.page
      this.pageInfo.limit = payload.limit
      const res = await getContractList({
        ...payload,
        companyId: this.companyId,
      })
      this.data = res.data?.records || []
      this.pageInfo.total = Number(res.data?.total) || 0
      this.loading = false
    },
    openHandleContract(status, payload) {
      this.$refs.handleContractRef.init(status, payload, this.companyId)
    },
    // 初始化
    init({ id }) {
      this.companyId = id || ""
      this.handleGetContractList({ page: 1, limit: 10 })
      this.dialogVisible = true
    },
    // 关闭
    close() {
      this.dialogVisible = false
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.handleGetContractList({
        page: payload,
        limit: this.pageInfo.limit,
      })
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.handleGetContractList({ page: 1, limit: payload })
    }
  },
}
</script>

<style lang="scss" scoped>
.contractAdmin {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
    &.is-disabled {
      color: #808080 !important;
      cursor: no-drop;
    }
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
